import { createContext, useCallback } from 'react';
import { createUseDefinedContext } from '../../utils/hooks/createUseDefinedContext';
import { createPropsContextProvider } from '../../utils/createPropsContextProvider';

export interface ListSelection {
  selectedId?: string;
  onClick: (id: string) => void;
}

const context = createContext<ListSelection | undefined>(undefined);

export const ListSelectionProvider = createPropsContextProvider(context);

export const useListSelectionContext = createUseDefinedContext(
  context,
  'useListSelectionContext requires ListSelectionContext to read list item properties'
);

export const useListSelection = (id: string) => {
  const { onClick, selectedId } = useListSelectionContext();

  const selected = selectedId === id;
  const onClickInjected = useCallback(() => onClick(id), [id, onClick]);

  return { selected, onClick: onClickInjected };
};
